import React from 'react';
import { Container } from 'components/UI';
import IntroDefault from './IntroDefault';
import { getMeetupDateString } from 'utils';
import { meetupDate, meetupStartTime, timeZone } from 'define';

import * as styles from './Intro.module.scss';

export default function Intro(props) {
  const preparedProps = {
    ...props,
    date: getMeetupDateString(meetupDate),
    meetupStartTime: meetupStartTime,
    timeZone: timeZone,
  };

  return (
    <Container className={styles.container} background="transparent">
      <IntroDefault {...preparedProps} />
    </Container>
  );
}
